import React, { FC, useCallback } from "react";
import classNames from "classnames/dedupe";
import { IInputAdornmentProps } from "./InputAdornment.interface";

const InputAdornment: FC<IInputAdornmentProps> = ({
  disabled,
  position = "end",
  classes,
  clickable = false,
  hideOnFocus = true,
  children,
  onClick,
}) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) =>
      clickable && onClick && onClick(event),
    [clickable, onClick],
  );
  return (
    <div
      className={classNames(
        "form-floating-icon",
        {
          "form-floating-icon--pos-left": position === "start",
          "form-floating-icon--pos-right": position === "end",
          "text-color-grey-500": disabled,
          "form-floating-icon--hide-on-input-focus": hideOnFocus,
        },
        [clickable ? "cursor-pointer" : "pointer-events-none"],
        classes?.root,
      )}
      onClick={handleClick}
      data-testid="InputAdornment"
    >
      {children}
    </div>
  );
};

export default InputAdornment;
